import * as types from '../../constants/log/nftTransactionLogConstants';

export const nftTransactionLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    tokenType,
    targetAccount,
    transactionType,
    nftUid,
    callback,
    error
  }
) => ({
  type: types.NFT_TRANSACTIONLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  tokenType,
  targetAccount,
  transactionType,
  nftUid,
  callback,
  error,
});

export const nftTransactionLogList = (list) => ({
  type: types.NFT_TRANSACTIONLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setNFTTransactionLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_NFT_TRANSACTIONLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const nftTransactionLogPageReset = () => ({
  type: types.NFT_TRANSACTIONLOG_PAGE_RESET,
});
